import { Flex, Spin, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import {} from // useGetOrganizationOrganizationOrganizationIdGetQuery,
// useLeaveFromOrganizationOrganizationOrganizationIdLeavePostMutation,
'@shared/api';
import { OrganizationEditForm } from '@modules/profile/organization/organization-edit-form/ui/organization-edit-form';
import styles from './organization-details.module.scss';
import { useLocation, useParams } from 'react-router-dom';
import { ScrollContainer } from '@shared/ui/scroll-container';
import { router } from '@app/providers/router/router-provider';
import { Routes } from '@shared/constants/routes';
import { useGlobalConfirmModalActions } from '@shared/redux/ducks/global-confirm-modal';
import { useEffect } from 'react';

export const OrganizationDetails = () => {
  const { Text, Link } = Typography;
  const { t } = useTranslation('translation', { keyPrefix: 'profile.organization' });
  const { organizationId } = useParams();
  const location = useLocation();

  // const [leaveFromOrganizationMutation] = useLeaveFromOrganizationOrganizationOrganizationIdLeavePostMutation();

  const { openConfirmModal } = useGlobalConfirmModalActions();

  // const {
  //   data: organization,
  //   isLoading,
  //   refetch,
  // } = useGetOrganizationOrganizationOrganizationIdGetQuery(
  //   {
  //     organizationId: Number(organizationId),
  //   },
  //   { skip: !organizationId },
  // );

  // const handleLeaveFromOrganization = async () => {
  //   if (!organizationId) return;

  //   try {
  //     await leaveFromOrganizationMutation({ organizationId: Number(organizationId) }).unwrap();
  //     router.navigate(Routes.space.root);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const handleOpenConfirmModal = () => {
  //   openConfirmModal({
  //     title: t('leaveOrganization'),
  //     text: (
  //       <Trans
  //         t={t}
  //         i18nKey="leaveOrganizationText"
  //         values={{
  //           name: organization?.title,
  //           interpolation: { escapeValue: false },
  //         }}
  //         components={{ bold: <Text strong /> }}
  //       />
  //     ),
  //     onConfirm: handleLeaveFromOrganization,
  //   });
  // };

  // useEffect(() => {
  //   refetch();
  // }, [location.pathname]);

  // if (isLoading) {
  //   return (
  //     <Flex align="center" justify="center" flex={1}>
  //       <Spin />
  //     </Flex>
  //   );
  // }

  return (
    <Flex className={styles.root} flex={1} vertical>
      <ScrollContainer>
        <Flex className={styles.container} vertical align="center" justify="center">
          <Text className={styles.title}>{t('detailsTitle')}</Text>

          {/* <OrganizationEditForm organizationInfo={organization} /> */}

          {/* <Flex align="center" justify="center" style={{ marginTop: '96px' }}>
            <Link
              style={{
                fontSize: '20px',
                lineHeight: '24px',
                fontWeight: '500',
                color: '#ED131C',
              }}
              onClick={handleOpenConfirmModal}
            >
              {t('leaveOrganization')}
            </Link>
          </Flex> */}
        </Flex>
      </ScrollContainer>
    </Flex>
  );
};
